import { CustomInput } from "./styled.components";

const TextField = (props: any) => {
  return <CustomInput {...props} size="small" variant="outlined" />;
};

export default TextField;
